import React from 'react'

export default function SurrenderCalendar () {
  return (
    <div>
      SurrenderCalendar
    </div>
  )
}
